module.exports = __webpack_public_path__ + "static/media/22792151_1629540193787832_5083217469933605595_o.165c5df7.jpg";